module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/424584aa0d2284485934a8edf4645566.png";